import { Form } from 'antd';
import { snakeCase } from 'lodash';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { BooleanField } from '../fields';
import {
  BooleanFieldFilter,
  BooleanFilterOperationType,
  BooleanFilterOperationTypes,
  isOptional,
} from '../filters/boolean';
import { Select } from './components';
import { CyWrapper } from './wrappers/cy-wrapper';

interface Props {
  filter: BooleanFieldFilter;
  onChange: (filter: BooleanFieldFilter) => void;
  getFilterOperationTypeOptions?: (field: BooleanField) => BooleanFieldFilter[];
  getOperationOptionRenderer?: (
    type: BooleanFilterOperationType,
  ) => null | JSX.Element;
}

const options = (field: BooleanField): BooleanFieldFilter[] =>
  BooleanFilterOperationTypes.filter(
    (x) => !field.metaData?.required || !isOptional(x),
  ).map(
    (type) =>
      ({
        field,
        type,
      } as any as BooleanFieldFilter),
  );

export const BooleanCriteria: FC<Props> = ({
  filter,
  onChange,
  getFilterOperationTypeOptions = options,
  getOperationOptionRenderer,
}) => (
  <Form.Item>
    <Select
      disabled={filter == null}
      value={filter?.type}
      onChange={(selected) =>
        onChange({
          ...filter,
          type: selected,
        } as any)
      }
    >
      {(filter?.field == null
        ? []
        : getFilterOperationTypeOptions(filter.field)
      ).map((option) => (
        <Select.Option key={option.type} value={option.type}>
          {getOperationOptionRenderer?.(option.type) ?? (
            <CyWrapper filter={filter} option={option}>
              <FormattedMessage
                id={`task_list.filters.${snakeCase(
                  BooleanFilterOperationType[option.type],
                )}`}
              />
            </CyWrapper>
          )}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
